/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Parameter } from './parameter';
import { S3PropertiesLocation } from './s3PropertiesLocation';


export interface JobCreateRequest { 
    /**
     * The namespace of the job
     */
    namespace: string;
    /**
     * The name of the job
     */
    jobName: string;
    /**
     * List of key/value pairs that will be made available to the job when it is executed. These parameters will override any                   parameters defined as                   part of the job definition                
     */
    parameters?: Array<Parameter>;
    s3PropertiesLocation?: S3PropertiesLocation;
}
